<template>
  <el-table
    class="table-responsive table-flush kc-entries"
    header-row-class-name="thead-light"
    row-class-name="kc-entry-row"
    row-key="key"
    :data="rows"
    @row-click="selectRow"
  >
    <el-table-column :label="copy.table.ticket" min-width="220px">
      <template v-slot="{ row }">
        <span class="kc-entry-label">{{ row.label }}</span>
        <badge v-if="row.isAutomatic" type="info">{{ copy.adjustments.automatic }}</badge>
      </template>
    </el-table-column>
    <el-table-column :label="copy.table.date" prop="date" min-width="130px"></el-table-column>
    <el-table-column :label="copy.table.amount" min-width="200px" align="right">
      <template v-slot="{ row }">
        <span class="kc-entry-amount" :class="{ 'kc-entry-amount--adjustment': row.isAdjustment }">{{ row.amount }}</span>
        <badge v-if="row.isIncomplete" type="warning">{{ copy.incomplete }}</badge>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { Table, TableColumn } from 'element-ui';
import { KITCHEN_CHARGES_COPY } from '@/components/KitchenCharges/copy';
import { entryRow } from '@/components/KitchenCharges/chargeEntries';

export default {
  name: 'KitchenChargesTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  props: {
    entries: { type: Array, required: true },
    currency: { type: String, required: true },
  },
  data() {
    return { copy: KITCHEN_CHARGES_COPY };
  },
  computed: {
    rows() {
      return this.entries.map((entry) => ({ ...entryRow(entry, this.currency), entry }));
    },
  },
  methods: {
    selectRow(row) {
      this.$emit('select', row.entry);
    },
  },
};
</script>

<style scoped>
.kc-entries ::v-deep .kc-entry-row {
  cursor: pointer;
}
.kc-entry-label {
  font-weight: 600;
  color: #32325d;
  margin-right: 8px;
}
.kc-entry-amount {
  font-weight: 600;
  color: #32325d;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}
.kc-entry-amount--adjustment {
  color: #525f7f;
}
.kc-entry-amount + .badge {
  margin-left: 8px;
}
</style>
